if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    // Upgrade WA-03: één verzendbalk. De opmaak (.aza-ship, vrachtwagen als
    // lijn-icoon, voortgang) stond in assets/custom.js, dat dit element na het
    // tekenen ombouwde met een MutationObserver op de hele pagina. Nu tekent
    // het component zichzelf; connectedCallback, zodat de balk ook na
    // refreshCart (nieuwe HTML) weer opbouwt.
    connectedCallback() {
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const goal = Math.round(freeShippingThreshold * (window.Shopify && Shopify.currency && Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const remaining = goal - cartTotal;
      const done = remaining <= 0;
      const ratio = done || goal <= 0 ? 1 : Math.max(0, Math.min(1, cartTotal / goal));

      const prefix = this.dataset.azaMoneyPrefix || '';
      let amount = this._formatMoney(Math.abs(remaining), KROWN.settings.shop_money_format);
      if (prefix && !amount.startsWith(prefix)) amount = prefix + amount;
      const escape = (str) => String(str).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
      const message = done
        ? escape(window.KROWN.settings.locales.shipping_notice_eligible_for_free)
        : escape(window.KROWN.settings.locales.shipping_notice_remaining_to_free).replace(escape('{{ remaining_amount }}'), `<strong>${escape(amount)}</strong>`);

      this.innerHTML = `
        <div class="aza-ship${done ? ' is-complete' : ''}">
          <span class="aza-ship__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="14" height="11" rx="1.5"/><path d="M15 8h4l3.5 3.5V15H15z"/><circle cx="5.5" cy="18" r="2.4"/><circle cx="18" cy="18" r="2.4"/></svg></span>
          <div class="aza-ship__body">
            <p class="aza-ship__msg" role="status">${message}</p>
            <span class="aza-ship__track"><span class="aza-ship__fill"></span></span>
          </div>
        </div>
      `;

      // Pas na de eerste verf vullen, zodat de balk zichtbaar oploopt
      // (transform: scaleX, geen layout per frame).
      const fill = this.querySelector('.aza-ship__fill');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        fill.style.transform = `scaleX(${ratio.toFixed(3)})`;
      }));

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}